import { Injectable, Signal, computed, inject } from '@angular/core';
import { CurrentUser, UserService } from '../user.service';
import { ApiSessionService } from './api-session.service';

@Injectable()
export class ApiUserService extends UserService {
  private readonly session = inject(ApiSessionService);
  readonly currentUser: Signal<CurrentUser> = computed(() => ({ name: this.session.user().name, initials: this.session.user().avatarInitials }));
}
